/** Funções puras do fluxo /cadastrar (testáveis sem React). */

export function onlyDigits(s: string): string {
  return s.replace(/\D/g, "");
}

export function formatPhoneBr(d: string): string {
  const x = onlyDigits(d).slice(0, 11);
  if (x.length <= 2) return x;
  if (x.length <= 7) return `(${x.slice(0, 2)}) ${x.slice(2)}`;
  return `(${x.slice(0, 2)}) ${x.slice(2, 7)}-${x.slice(7)}`;
}

export function formatCpf(d: string): string {
  const x = onlyDigits(d).slice(0, 11);
  if (x.length <= 3) return x;
  if (x.length <= 6) return `${x.slice(0, 3)}.${x.slice(3)}`;
  if (x.length <= 9)
    return `${x.slice(0, 3)}.${x.slice(3, 6)}.${x.slice(6)}`;
  return `${x.slice(0, 3)}.${x.slice(3, 6)}.${x.slice(6, 9)}-${x.slice(9)}`;
}

export function formatCep(d: string): string {
  const x = onlyDigits(d).slice(0, 8);
  if (x.length <= 5) return x;
  return `${x.slice(0, 5)}-${x.slice(5)}`;
}

export function formatCardNumber(d: string): string {
  const x = onlyDigits(d).slice(0, 19);
  const parts: string[] = [];
  for (let i = 0; i < x.length; i += 4) {
    parts.push(x.slice(i, i + 4));
  }
  return parts.join(" ");
}

export function cardBrandHint(num: string): string | null {
  const d = onlyDigits(num);
  if (d.startsWith("4")) return "Visa";
  if (/^5[1-5]/.test(d) || /^2[2-7]/.test(d)) return "Mastercard";
  if (/^3[47]/.test(d)) return "Amex";
  return null;
}

export function validateCpfDigits(cpf: string): boolean {
  const d = onlyDigits(cpf);
  if (d.length !== 11 || /^(\d)\1{10}$/.test(d)) return false;
  let s = 0;
  for (let i = 0; i < 9; i++) s += parseInt(d[i]!, 10) * (10 - i);
  let r = (s * 10) % 11;
  if (r === 10 || r === 11) r = 0;
  if (r !== parseInt(d[9]!, 10)) return false;
  s = 0;
  for (let i = 0; i < 10; i++) s += parseInt(d[i]!, 10) * (11 - i);
  r = (s * 10) % 11;
  if (r === 10 || r === 11) r = 0;
  return r === parseInt(d[10]!, 10);
}

export type CadastroStepKey =
  | "nome"
  | "email"
  | "senha"
  | "nascimento"
  | "telefone"
  | "cpf"
  | "endereco"
  | "success";

export const CADASTRO_STEP_ORDER: CadastroStepKey[] = [
  "nome",
  "email",
  "senha",
  "nascimento",
  "telefone",
  "cpf",
  "endereco",
  "success",
];

export function nextCadastroStep(s: CadastroStepKey): CadastroStepKey | null {
  const i = CADASTRO_STEP_ORDER.indexOf(s);
  if (i < 0 || i >= CADASTRO_STEP_ORDER.length - 1) return null;
  return CADASTRO_STEP_ORDER[i + 1]!;
}
